import React, { useState, useEffect } from "react";
import "./termsOfUse.css";
import { Breadcrumb, Button, Modal, Table } from "antd";
import { editIcon, homeIcon } from "../../assets";
import UpdateTerms from "../../components/updateTermsOfUse/updateTermsOfUse";
import routes from "../../api/routes";
import { callApi } from "../../api/apiCaller";
import Loader from "../../components/loader/loader";
import { useDispatch } from "react-redux";

const TermsOfUse = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);

  const getProducts = () => {
    callApi(
      "GET",
      `${routes.getTermsOfUse}`,
      null,
      setIsLoading,
      (res) => {
        console.log("response receivedhadahfahshfda", res?.data);
        setProducts(res?.data || []);
      },
      (error) => {
        console.log("error", error);
      }
    );
  };

  const handleViewDetails = (term) => {
    setSelectedTerm(term);
    setShowModal(true);
  };

  const handleEdit = (term) => {
    setSelectedTerm(term);
    setEditModalVisible(true);
  };

  const handleUpdate = (updatedTerm) => {
    setEditModalVisible(false);
    getProducts();
  };

  const columns = [
    {
      title: "Data", // Display the `data` field content in an organized way
      dataIndex: "data",
      render: (data) => (
        <Table
          dataSource={data}
          columns={[
            {
              title: "Question",
              dataIndex: "question",
              key: "question",
            },
            {
              title: "Description",
              dataIndex: "description",
              key: "description",
            },
          ]}
          pagination={false}
          bordered
          size="small"
        />
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      render: (text, record) => (
        <div
          onClick={() => handleEdit(record)}
          className="product-list-edit-icon"
        >
          <img src={editIcon} alt="Edit Icon" />
        </div>
      ),
    },
  ];

  const data = products?.map((item, index) => {
    console.log("Product Item:", JSON.stringify(item));
    return {
      key: index,
      _id: item?._id,
      data: item?.data || [],
      edit: item,
    };
  });

  useEffect(() => {
    getProducts();
  }, []);

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="Home Icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>TermsOfUse</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Terms of Use</h1>
      </div>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={
            products.length > 10
              ? { showSizeChanger: true, showQuickJumper: true }
              : false
          }
          className="subscriptionapi-table"
        />
      </div>

      {selectedTerm && (
        <Modal
          title="Term Details"
          visible={showModal}
          onCancel={() => setShowModal(false)}
          footer={[
            <Button key="close" onClick={() => setShowModal(false)}>
              Close
            </Button>,
          ]}
        >
          <Table
            dataSource={selectedTerm.data}
            columns={[
              {
                title: "Question",
                dataIndex: "question",
                key: "question",
              },
              {
                title: "Description",
                dataIndex: "description",
                key: "description",
              },
            ]}
            pagination={false}
            bordered
            size="small"
          />
        </Modal>
      )}

      {selectedTerm && (
        <UpdateTerms
          visible={editModalVisible}
          onCancel={() => setEditModalVisible(false)}
          term={selectedTerm}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default TermsOfUse;
